import { toZonedTime } from 'date-fns-tz';
import { getFormattedDate } from 'lib/common';
import { analyticsLocalStorage } from '.';

export default ({ courseId, searchString, timeZone, type, userId }) => {
  const existingEntry = analyticsLocalStorage.findExistingEntry({
    type: 'search',
    userId
  });

  const data = existingEntry ? existingEntry.values.data : [];

  const zonedDate = toZonedTime(Date.now(), timeZone);

  data.push({
    courseId,
    searchString,
    type,
    date: getFormattedDate({ date: zonedDate, dateFormat: 'y-MM-dd' })
  });

  analyticsLocalStorage.createOrUpdateEntry({
    key: existingEntry ? existingEntry.key : null,
    values: {
      type: 'search',
      courseId,
      userId,
      data
    }
  });
};
